// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ledZ","comment":"styles_comment__DpN19"};